import { northBergenConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function NorthBergenPage() {
  return <CityPageTemplate config={northBergenConfig} />;
}